// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".simple_home_public-module__container--j5iAW{max-width:560px;margin:56px auto;padding-right:24px;padding-left:24px;overflow:hidden}\n", ""]);
// Exports
exports.locals = {
	"container": "simple_home_public-module__container--j5iAW"
};
module.exports = exports;
